import { z } from 'zod'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { materialObject } from '../material/materialObject'
import { materialRequestItemObject, materialRequestObject } from '../materialRequest/materialRequestObject'

export const materialDeliveryItemObject = z.object({
  id: z.string().uuid(),
  materialDeliveryId: z.string().uuid(),
  materialRequestItemId: materialRequestItemObject.shape.id.nullish(),
  materialId: materialObject.shape.id,
  deliveredQuantity: z.number().int().nonnegative(),
  previousDeliveredQuantity: z.number().int().nonnegative().nullish(),
  requestedQuantity: z.number().int().nonnegative().nullish(),
  quantityDifference: z.number().int().nullish(),
  materialInventoryId: z.string().uuid().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  material: materialObject.nullish(),
})

export const materialDeliveryObject = z.object({
  id: z.string().uuid(),
  materialRequestId: materialRequestObject.shape.id,
  citizenId: citizenObject.shape.id.nullish(),
  deliveryDate: dateOrIsoString(),
  protocolId: z.string().uuid().nullish(),
  protocolCode: z.number().int().positive().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  citizen: citizenObject.nullish(),
  request: materialRequestObject.nullish(),
  items: z.array(materialDeliveryItemObject).nullish(),
})

export type MaterialDeliveryItemType = z.infer<typeof materialDeliveryItemObject>
export type MaterialDeliveryType = z.infer<typeof materialDeliveryObject>

export const propertyMap = {
  id: sql`material_delivery.id`,
  materialRequestId: sql`material_delivery.material_request_id`,
  citizenId: sql`material_request.citizen_id`,
  deliveryDate: sql`material_delivery.delivery_date`,
  protocolId: sql`protocol.id`,
  protocolCode: sql`protocol.code`,
  createdAt: sql`material_delivery.created_at`,
  updatedAt: sql`material_delivery.updated_at`,
  deletedAt: sql`material_delivery.deleted_at`,
}

export const itemPropertyMap = {
  id: sql`material_delivery_item.id`,
  materialDeliveryId: sql`material_delivery_item.material_delivery_id`,
  materialRequestItemId: sql`material_delivery_item.material_request_item_id`,
  materialId: sql`material_delivery_item.material_id`,
  deliveredQuantity: sql`material_delivery_item.delivered_quantity`,
  previousDeliveredQuantity: sql`material_delivery_item.previous_delivered_quantity`,
  materialInventoryId: sql`material_delivery_item.material_inventory_id`,
  createdAt: sql`material_delivery_item.created_at`,
  updatedAt: sql`material_delivery_item.updated_at`,
  deletedAt: sql`material_delivery_item.deleted_at`,
}
